import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { css } from 'aphrodite/no-important';

import {
  CustomerBooking,
  FilterType,
  TicketTypeFilters,
  BookingStatusFilters,
  FilterTypes,
} from '../../types';

import styles from './styles';
import FilterMenuButton from './FilterMenuButton';
import messages from './messages';
import { filterMenuSelectionLabel } from './util';

interface Props {
  bookings: Array<CustomerBooking>;
  filteredBookings: Array<CustomerBooking>;
  appliedFilters: Set<FilterType>;
  addFilters: (filters: Set<FilterType>) => void;
}

const FilterMenu = ({ addFilters, appliedFilters }: Props) => {
  const [checkedItems, setCheckedItems] = useState<Set<FilterType>>(new Set());
  const appliedTicketTypeFilters = new Set(
    Object.values(TicketTypeFilters).filter((filter) => appliedFilters.has(filter))
  );
  const appliedBookingStatusFilters = new Set(
    Object.values(BookingStatusFilters).filter((filter) => appliedFilters.has(filter))
  );

  const applyTicketTypeButtonClickHandler = (checkedItemsList: Set<FilterType>) => {
    const mergedSet = new Set([...appliedBookingStatusFilters, ...checkedItemsList]);
    applyFilters(mergedSet);
  };

  const applyBookingStatusButtonClickHandler = (checkedItemsList: Set<FilterType>) => {
    const mergedSet = new Set([...appliedTicketTypeFilters, ...checkedItemsList]);
    applyFilters(mergedSet);
  };

  const applyFilters = (filters: Set<FilterType>) => {
    setCheckedItems(filters);
    addFilters(filters);
  };

  const applyClearAllClickHandler = (type: FilterTypes) => {
    const filtersToClear: Set<FilterType> =
      type === FilterTypes.TicketType
        ? new Set(Object.values(TicketTypeFilters))
        : new Set(Object.values(BookingStatusFilters));

    const result = new Set([...checkedItems].filter((item) => !filtersToClear.has(item)));
    setCheckedItems(result);
    addFilters(result);
  };

  return (
    <div className={css(styles.filterButtonWrapper)}>
      <strong className={css(styles.bookingsFilterText)}>
        <FormattedMessage {...messages.filterBy} />
      </strong>
      <FilterMenuButton
        type={FilterTypes.TicketType}
        onApplyClick={applyTicketTypeButtonClickHandler}
        appliedFilters={appliedTicketTypeFilters}
        applyClearAllClickHandler={applyClearAllClickHandler}
        label={filterMenuSelectionLabel({
          appliedFilters: appliedTicketTypeFilters,
          defaultMessage: messages.ticketType,
        })}
      />
      <FilterMenuButton
        type={FilterTypes.BookingStatus}
        onApplyClick={applyBookingStatusButtonClickHandler}
        appliedFilters={appliedBookingStatusFilters}
        applyClearAllClickHandler={applyClearAllClickHandler}
        label={filterMenuSelectionLabel({
          appliedFilters: appliedBookingStatusFilters,
          defaultMessage: messages.bookingStatus,
        })}
      />
    </div>
  );
};

export default FilterMenu;
